module.exports = __webpack_public_path__ + "static/media/li.64c4108b.svg";